import { useEffect, useState } from 'react';

const useTimer = ({
  active = false,
  initMin = 5,
  initSec = 0
}: {
  active?: boolean | number;
  initMin?: number;
  initSec?: number;
}) => {
  const isActive = !!active;
  //5분 고정이 아닐 경우 Props로 전달
  const [min, setMin] = useState(isActive ? initMin : 0);
  const [sec, setSec] = useState(isActive ? initSec : 0);
  const [isEnableTimer, setIsEnableTimer] = useState(isActive);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isActive) {
      timer = setInterval(() => {
        if (Number(sec) > 0) return setSec(Number(sec) - 1);

        if (Number(sec) !== 0) return;

        if (Number(min) === 0) {
          setIsEnableTimer(false);
          clearInterval(timer);
          return;
        }

        setMin(Number(min) - 1);
        setSec(59);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [min, sec, active]);

  // 액티브 전환시에는 초기값으로 재할당
  useEffect(() => {
    if (!active) return;

    setMin(initMin);
    setSec(initSec);
  }, [active]);

  return { min, sec: sec < 10 ? `0${sec}` : sec, isEnableTimer };
};

export default useTimer;
